var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScholarshipAgreementsSectionInnerLeftIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 116,
    height: 81.214,
    viewBox: "0 0 116 81.214",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "graduation-cap-solid_1_",
    "data-name": "graduation-cap-solid (1)",
    d: "M57.986,32a12.822,12.822,0,0,0-4.3.743L2.851,51.1a4.361,4.361,0,0,0,0,8.192l10.494,3.788A29.838,29.838,0,0,0,8.687,79.106V84.2c0,5.147-1.957,10.458-4.042,14.645a48.052,48.052,0,0,1-4.078,6.815,2.908,2.908,0,0,0,1.613,4.567l11.6,2.9a2.891,2.891,0,0,0,2.247-.362,2.839,2.839,0,0,0,1.287-1.885,46.727,46.727,0,0,0-.381-19.7,40.079,40.079,0,0,0-2.447-7.612V79.106a24.068,24.068,0,0,1,5.057-14.772,22.13,22.13,0,0,1,8.917-6.47L56.917,46.681a2.893,2.893,0,0,1,2.121,5.383L30.582,63.247a16.638,16.638,0,0,0-5.836,3.915L53.672,77.6a12.787,12.787,0,0,0,8.591,0L113.121,59.3a4.361,4.361,0,0,0,0-8.192L62.282,32.743A12.822,12.822,0,0,0,57.986,32Zm-34.8,68.148c0,6.4,15.587,13.05,34.8,13.05s34.8-6.652,34.8-13.05L90.012,73.8,64.239,83.111a18.521,18.521,0,0,1-12.506,0L25.96,73.8Z",
    transform: "translate(0.016 -32)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScholarshipAgreementsSectionInnerLeftIcon);
export default __webpack_public_path__ + "static/media/scholarship-agreements-section-inner-left-icon.92d38caa6cf02a36f274b9b920bb6e69.svg";
export { ForwardRef as ReactComponent };